import 'css-chunksrc/client/scenes/workloads/calendar/years/year/styles.scss';export default {
  "year": "_year_my6ns_1",
  "yearName": "_yearName_my6ns_14",
  "months": "_months_my6ns_29",
  "month": "_month_my6ns_29",
  "monthNbr": "_monthNbr_my6ns_51",
  "even": "_even_my6ns_55",
  "odd": "_odd_my6ns_59"
};